import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";
import * as Annotation from "chartjs-plugin-annotation";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Bar,
  props: {
    averages: {},
    sds: {},
    average: {
      default: 0,
    },
    universityAverage: {
      default: 0,
    },
    averageLabel: {
      default: "ค่าเฉลี่ยรวม"
    },
    labels: {},
    yAxisLabel: {
      default: "คะแนนเฉลี่ย",
    },
    yMax: {
      default: 20,
    },
    enableAverageLine: {
      default: true
    },
    enableSdLine: {
      default: true,
    },
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            type: "bar",
            label: "ส่วนเบี่ยงเบนมาตรฐาน",
            backgroundColor: "#c9b9d1",
            data: this.sds,
          },
          {
            type: "bar",
            label: "ค่าเฉลี่ย",
            backgroundColor: "#bd9acf",
            data: this.averages,
          },
        ],
      },
      {
        title: {
          display: false,
          text: "",
        },
        elements: {
          point: {
            radius: 0,
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: this.yMax,
              },
              scaleLabel: {
                display: true,
                labelString: this.yAxisLabel,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                autoSkip: false,
                stepSize: 1,
              },
              stacked: true,
              maxBarThickness: 50,
              beginAtZero: true,
            },
          ],
        },
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: this.universityAverage,
              borderColor: "#9E76B4",
              borderWidth: 3,
              label: {
                enabled: this.enableAverageLine,
                content: `${this.universityAverage.toFixed(2)}`,
                position: "center",
                backgroundColor: "#9E76B4",
              },
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: this.average,
              borderColor: "#93D124",
              borderWidth: 3,
              label: {
                enabled: this.enableSdLine,
                content: `${this.average.toFixed(2)}`,
                position: "right",
                backgroundColor: "#93D124",
                fontColor: "#ffffff"
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            align: 'end',
            anchor: 'end',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            borderColor: 'rgba(128, 128, 128, 0.7)',
            borderRadius: 4,
            borderWidth: 1,
            color: function (context) {
              const i = context.dataIndex;
              const value = context.dataset.data[i];

              const next = context.dataset.data[i + 1];

              const diff = next !== undefined ? value - next : 0;
              const color = diff == 0 ? 'gray' : value > next ? 'green' : 'red';

              return color;
            },
            display: function (context) {
              return context.dataset.label == 'ค่าเฉลี่ย';
            },
            font: {
              size: 11,
              weight: 600
            },
            offset: 8,
            formatter: function (value, context) {
              const i = context.dataIndex;
              const next = context.dataset.data[i + 1];

              const diff = next !== undefined ? value - next : 0;
              const glyph = diff == 0 ? '\u25C6' : value > next ? '\u25B2' : '\u25BC';

              return glyph + ' ' + diff.toFixed(2);
            }
          }
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
  watch: {},
};
